
































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { AttendeeResponseResult } from 'src/assets/AttendeeItemData'
import SessionResult from 'components/attendee/SessionResult.vue'
import SlideView from 'components/presenter/item/topic/viewer/View.vue'
import SessionDurationFormat from 'components/presenter/item/session/SessionDurationFormat.vue'
import { Item, Session, PersonPublicProfile } from 'src/graphql/types'

@Component({
  components: {
    SessionResult,
    SlideView,
    SessionDurationFormat
  }
})
export default class SessionAttendeeResponse extends Vue {
  showAll = false
  showErrors = false

  @Prop()
  readonly topic!: Item

  @Prop()
  readonly session!: Session

  @Prop()
  readonly currSlide!: Json

  @Prop()
  readonly attendeeResponseResult!: AttendeeResponseResult

  @Prop()
  readonly attendeePublicProfile!: PersonPublicProfile

  @Prop()
  readonly contactName!: string

  @Prop({ default: true })
  readonly feedback!: boolean

  @Prop({ default: () => { return {} } })
  readonly stats!: Json

  get attendee () {
    return this.attendeeResponseResult.attendeeItemData.attendee
  }

  get response () {
    return this.attendee.data
  }

  get result () {
    return this.attendeeResponseResult.slides
  }

  // get currQuizQuestion () {
  //   if (this.currSlide && ['Choice', 'YesNo', 'Order', 'Number', 'Gaps', 'Essay'].includes(this.currSlide.type)) {
  //     return this.currSlide
  //   }
  // }

  get slides () {
    if (this.currSlide && !this.showAll && !this.showErrors) {
      return [this.currSlide]
    } else {
      const slides = this.attendeeResponseResult.attendeeItemData.slides.map(s => this.topic.data?.slides[ s.id ] || s)
      if (this.showErrors) {
        // @ts-ignore
        return slides.filter(s => this.result[s.id] && this.result[s.id].pointsMax && this.result[s.id].points !== this.result[s.id].pointsMax)
      } else {
        return slides
      }
    }
  }
}
